import React from "react";
import Lottie from "lottie-react";
import "./Inicio.css";
import HeaderPlataforma from "../Header2/Header2";
import supportAnim from "../../Assets/Animations/Hr (3).json";
import securityAnim from "../../Assets/Animations/Security.json";
import timeAnim from "../../Assets/Animations/time (2).json";
import academicAnim from "../../Assets/Animations/Academic Background.json";
import educationAnim from "../../Assets/Animations/Learned.json";
import messageAnim from "../../Assets/Animations/chat.json";
import downloadAnim from "../../Assets/Animations/download.json";
import Footer2 from "../Footer2/Footer2";

function MainInicio() {
  return (
    <>
      <HeaderPlataforma />

      {/* HERO SECTION */}
      <section className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <span className="hero-badge">Plataforma educativa</span>
            <h1>
              La plataforma que <br />
              ordena y conecta <span>tu institución</span>
            </h1>
            <p>
              Comunicación institucional, gestión académica y seguimiento
              educativo en un solo lugar, con acompañamiento real.
            </p>
            <a
              href='https://wa.me/message/ORWIOZ4UP74NM1' target="_blank"
              rel="noopener noreferrer"
              className="hero-cta"
            >
              Solicitar demo
            </a>
          </div>
          <div className="hero-animation">
            <Lottie animationData={educationAnim} loop className="lottie-icon" />
          </div>
        </div>
      </section>

      {/* VISIÓN GENERAL */}
      <section className="vision-pro-container">
        <div className="vision-pro-content reveal">
          <h2 className="vision-pro-title">
            Todo lo que una institución necesita,
            <span> en un solo ecosistema</span>
          </h2>
          <p className="vision-pro-subtitle">
            Tresaedu integra personas, procesos y comunicación en una única
            plataforma, adaptándose a la realidad de cada institución.
          </p>
          <div className="vision-divider"></div>
          <div className="vision-pro-cards">
            <div className="vision-pro-card">
              <i className="bx bx-buildings vision-icon"></i>
              <h4>Gestión administrativa</h4>
              <p>
                Ordená los procesos administrativos y mejorá la organización
                interna de tu institución.
              </p>
            </div>
            <div className="vision-pro-card featured">
              <i className="bx bx-book-open vision-icon"></i>
              <h4>Pedagogía</h4>
              <p>
                Acompañá los procesos educativos con herramientas pensadas para
                docentes y equipos pedagógicos.
              </p>
              <span className="vision-highlight">Eje central</span>
            </div>
            <div className="vision-pro-card">
              <i className="bx bx-message-rounded-dots vision-icon"></i>
              <h4>Comunicación</h4>
              <p>
                Centralizá la comunicación institucional y reducí la
                dispersión de mensajes.
              </p>
            </div>
          </div>
          <p className="vision-footer-text">
            Diseñada para crecer con tu institución, sin perder cercanía.
          </p>
        </div>
      </section>

      {/* ¿POR QUÉ TRESA? */}
      <section className="why-tresa-refined">
        <div className="why-tresa-wrapper">
          <div className="why-main">
            <div className="why-main-text">
              <span className="why-eyebrow">¿Por qué elegir Tresaedu?</span>
              <h2>
                Una plataforma pensada para
                <span> instituciones reales</span>
              </h2>
              <p>
                Diseñada para ordenar procesos, acompañar equipos
                y cuidar la información institucional desde el primer día.
              </p>
            </div>
          </div>
          <div className="why-features">
            <div className="why-feature">
              <Lottie animationData={securityAnim} loop />
              <div>
                <h4>Seguridad y confianza</h4>
                <p>
                  Información protegida, accesos controlados y resguardo
                  de datos institucionales.
                </p>
              </div>
            </div>
            <div className="why-feature">
              <Lottie animationData={supportAnim} loop />
              <div>
                <h4>Traspaso de datos acompañado</h4>
                <p>
                  Migramos la información existente para que la institución
                  empiece a trabajar sin fricciones.
                </p>
              </div>
            </div>
            <div className="why-feature">
              <Lottie animationData={timeAnim} loop />
              <div>
                <h4>Optimización del tiempo</h4>
                <p>
                  Menos tareas repetidas y más foco en lo pedagógico
                  y lo institucional.
                </p>
              </div>
            </div>
            <div className="why-feature">
              <Lottie animationData={academicAnim} loop />
              <div>
                <h4>Mirada educativa</h4>
                <p>
                  Cada decisión está pensada desde la dinámica real
                  de las instituciones educativas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* IMPLEMENTACIÓN */}
      <section className="implementation-section">
        <div className="implementation-wrapper">
          <div className="implementation-header">
            <h2>
              Implementar Tresaedu es un proceso
              <span> claro y acompañado</span>
            </h2>
            <p>
              Nos ocupamos del traspaso de datos, la configuración y el
              acompañamiento para que tu institución empiece a trabajar
              sin fricciones.
            </p>
          </div>
          <div className="implementation-steps">
            <div className="implementation-step">
              <div className="step-icon">
                <Lottie animationData={supportAnim} loop />
              </div>
              <h4>Traspaso de información</h4>
              <p>
                Migramos los datos existentes desde planillas o sistemas
                anteriores, cuidando la información institucional.
              </p>
            </div>
            <div className="step-divider" />
            <div className="implementation-step">
              <div className="step-icon">
                <Lottie animationData={securityAnim} loop />
              </div>
              <h4>Configuración institucional</h4>
              <p>
                Adaptamos la plataforma a la estructura, roles y dinámicas
                propias de tu institución.
              </p>
            </div>
            <div className="step-divider" />
            <div className="implementation-step">
              <div className="step-icon">
                <Lottie animationData={academicAnim} loop />
              </div>
              <h4>Acompañamiento y puesta en marcha</h4>
              <p>
                Capacitamos a los equipos y acompañamos el inicio para que
                la plataforma se integre naturalmente al día a día.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL - NUEVA SECCIÓN */}
      <section className="cta-final-section">
        <div className="cta-final-container">

          {/* Elemento decorativo orgánico */}
          <div className="cta-organic-shape"></div>

          <div className="cta-content-wrapper">

            {/* Columna de texto */}
            <div className="cta-text-column">
              <span className="cta-eyebrow">El siguiente paso</span>

              <h2 className="cta-title">
                Transformemos tu institución  <span />
                <span className="cta-title-highlight">   juntos</span>
              </h2>

              <p className="cta-subtitle">
                Te acompañamos desde el primer contacto hasta la implementación,
                con un enfoque 100% pedagógico y cero fricciones técnicas.
              </p>

              <div className="cta-actions-container">

                {/* Botón principal - WhatsApp Demo */}
                <a
                  href='https://wa.me/message/ORWIOZ4UP74NM1' target="_blank"
                  rel="noopener noreferrer"
                  className="cta-button cta-button-primary"
                >
                  <div className="button-content">
                    <div className="button-icon">
                      <Lottie
                        animationData={messageAnim}
                        loop={true}
                        style={{ width: 24, height: 24 }}
                      />
                    </div>
                    <span>Solicitar demo personalizada</span>
                  </div>
                  <span className="button-subtext">Vía WhatsApp</span>
                </a>

                {/* Separador elegante */}
                <div className="cta-separator">
                  <span className="separator-text">o</span>
                  <div className="separator-line"></div>
                </div>

                {/* Botón secundario - App Demo */}
                <a
                  href="/app-release.apk"
                  className="cta-button cta-button-secondary"
                  download="app-demo.apk"
                >
                  <div className="button-content">
                    <div className="button-icon">
                      <Lottie
                        animationData={downloadAnim}
                        loop={true}
                        style={{ width: 24, height: 24 }}
                      />
                    </div>
                    <span>Descargar app demo</span>
                  </div>

                  <span className="button-subtext">
                    Explorar la aplicación desde el celular
                  </span>
                </a>

              </div>

              {/* Texto de garantía */}
              <p className="cta-guarantee">
                <i className="bx bx-shield-alt"></i>
                Sin compromiso • Acompañamiento incluido • 100% educativo
              </p>
            </div>

            {/* Columna visual con micro-interacción */}
            <div className="cta-visual-column">
              <div className="cta-visual-container">
                <div className="floating-elements">
                  <div className="floating-element fe-1">
                    <i className="bx bx-check-circle"></i>
                    <span>Implementación guiada</span>
                  </div>
                  <div className="floating-element fe-2">
                    <i className="bx bx-user-voice"></i>
                    <span>Soporte dedicado</span>
                  </div>
                  <div className="floating-element fe-3">
                    <i className="bx bx-rocket"></i>
                    <span>Puesta en marcha</span>
                  </div>
                </div>
                <div className="cta-main-visual">
                  <div className="visual-circle">
                    <i className="bx bxs-institution"></i>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      <Footer2 />
    </>
  );
}

export default MainInicio;